import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { getValidationRules } from '../validation/validation'
import SignInSupportComponent from '../components/login/SignInSupportComponent'
import { loginSupport } from '../store/actions/session'
import SIGN_IN_RULES from '../validation/validationRules/signIn'

const mapDispatchToProps = {
    loginSupport,
}

const mergeProps = (
    stateProps,
    { loginSupport }, { history, location, ...state }
) => ({
    ...state,
    onSubmit: loginSupport,
})

export default withRouter(connect(null, mapDispatchToProps, mergeProps)(reduxForm({
    form: 'login',
    validate: getValidationRules([
        'email',
        'password',
    ], SIGN_IN_RULES),
})(SignInSupportComponent)))



// WEBPACK FOOTER //
// ./src/containers/SignInSupportContainer.js